import { useState, useEffect, useRef } from 'react'
import { multiTimeZoneHelper } from '../../utils/utils'
import { MULTI_TIME_ZONE } from '../../config'

const CurrentTime = () => {
    const [currentDT, setCurrentDT] = useState(new Date())
    const userRef = useRef(JSON.parse(localStorage.getItem('user')));

    useEffect(() => {
        let timerId = setInterval(() => {
            if(MULTI_TIME_ZONE){
              // let loggedInUser = JSON.parse(localStorage.getItem('user'))
              let offSetMinutes = userRef.current?.OffsetMinutes;
              setCurrentDT(multiTimeZoneHelper(offSetMinutes));
            }else{
              setCurrentDT(new Date());
            }
        }, 1000);
        return () => clearInterval(timerId);
    }, [])
    
  return (
    <div className='mainDivDateTime'>
    <div className="topDate">{currentDT.toDateString()}</div>
    <div className="topTime">{currentDT.toLocaleTimeString('en', { hour: 'numeric', hour12: true, minute: 'numeric', second: 'numeric' })}</div>
    </div>
  )
}

export default CurrentTime